export default __webpack_public_path__ + "static/media/backcard.98c33b99.jpg";